const images = {
  logo: require("@img/logo.png"),
  login_logo: require("@img/login_logo.png"),
  login_logo_title: require("@img/login_logo_title.png"),
  site_logo: require("@img/site_logo.png"),
  logo_title: require("@img/logo_title.png"),
  inc_calender01: require("@img/inc_calender01.png"),
  inc_calender02: require("@img/inc_calender02.png"),
  icn_arrowLeft: require("@img/icn_arrowLeft.png"),
  icn_arrow_img_left: require("@img/icn_arrow_img_left.png"),
  icn_arrow_img_right: require("@img/icn_arrow_img_right.png"),
  inc_img_plus: require("@img/inc_img_plus.png"),
  inc_img_plus_on: require("@img/inc_img_plus_on.png"),
  inc_img_minus: require("@img/inc_img_minus.png"),
  inc_img_minus_on: require("@img/inc_img_minus_on.png"),
  inc_circle_off: require("@img/inc_circle_off.png"),
  inc_circle_on: require("@img/inc_circle_on.png"),
  icn_active_search: require("@img/icn_active_search.png"),
  icn_default_search: require("@img/icn_default_search.png"),
  arrow_up_off: require("@img/arrow_up_off.png"),
  arrow_up_on: require("@img/arrow_up_on.png"),
};

export default images;
